import 'whatwg-fetch';
import { createStore } from '@vfde-sails/core';
import cancellationForm from 'Container/CancellationForm';
import './style.scss';
import { trackingMiddleware } from '@vfde-sails/tracking';

createStore({}, [trackingMiddleware]);
cancellationForm();
